var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { COLORS, FONTS, SIZES } from '@fupa/fupa-uikit';
import React from 'react';
import styled, { css } from 'styled-components';
import { LinkOnComponent } from 'app/components/links/link';
const Container = styled(LinkOnComponent).withConfig({
  componentId: "sc-1yv9b97-0"
})(["display:flex;flex:1 20%;height:", ";align-items:center;flex-direction:column;color:", ";cursor:pointer;-webkit-tap-highlight-color:rgba(180,180,180,0.1);", " ", ""], SIZES['44'], COLORS.darkerGrey, _ref => {
  let {
    selected
  } = _ref;
  return selected ? css(["color:", ";", "{background-color:", ";}"], COLORS.fupaSecondary, Circle, COLORS.fupaPrimary) : css([":hover,:focus{background-color:", ";", "{background-color:", ";}}"], COLORS.lighterGrey, Circle, COLORS.lightGrey);
}, _ref2 => {
  let {
    theme,
    selected
  } = _ref2;
  return theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: initial;\n    justify-content: center;\n    height: ", ";\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    margin: 0 0.375rem;\n\n    ", ";\n  "])), SIZES['48'], selected ? css(["", "{background-color:", ";}", "{color:", ";}"], Circle, COLORS.lighterGrey, Label, COLORS.fupaSecondary) : css([":hover,:focus{background-color:transparent;", "{background-color:", ";}", "{display:flex;}}"], Circle, COLORS.fupaSecondaryFocused, Label));
});
const Circle = styled.div.withConfig({
  componentId: "sc-1yv9b97-1"
})(["display:flex;border-radius:100%;width:", ";height:", ";background-color:", ";justify-content:center;align-items:center;", ""], SIZES['28'], SIZES['28'], COLORS.lighterGrey, props => props.theme.desktopLayout(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    background-color: rgba(256, 256, 256, 0.1);\n  "])), SIZES['48'], SIZES['48']));
const Label = styled.span.withConfig({
  componentId: "sc-1yv9b97-2"
})(["font-family:", ";font-size:", ";", ";"], FONTS.PTSans, FONTS['12'], props => props.theme.desktopLayout(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  padding-top: 1rem;\n  "])), COLORS.white));
export default function NavBarItem(_ref3) {
  let {
    isSelected,
    link,
    onClick,
    componentType,
    children,
    label,
    follow
  } = _ref3;
  return /*#__PURE__*/React.createElement(Container, {
    selected: isSelected,
    to: link,
    onClick: onClick,
    as: componentType,
    rel: follow ? 'follow' : 'nofollow',
    "data-sentry-element": "Container",
    "data-sentry-component": "NavBarItem",
    "data-sentry-source-file": "NavBarItem.tsx"
  }, /*#__PURE__*/React.createElement(Circle, {
    "data-sentry-element": "Circle",
    "data-sentry-source-file": "NavBarItem.tsx"
  }, children), /*#__PURE__*/React.createElement(Label, {
    "data-sentry-element": "Label",
    "data-sentry-source-file": "NavBarItem.tsx"
  }, label));
}